import DatePicker from 'react-date-picker'
import './datepickercomponent.css'

const ClearIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="19"
    height="19"
    viewBox="0 0 19 19"
    stroke="black"
    stroke-width="2"
    className="react-date-picker__clear-button__icon react-date-picker__button__icon"
  >
    <line x1="4" x2="15" y1="4" y2="15"></line>
    <line x1="15" x2="4" y1="4" y2="15"></line>
  </svg>
)

function InputDatePicker({
  value,
  onChange,
  onBlur,
  disabled = false,
  errors = false,
  touched = false,
  name = '',
  clearIcon = false,
  minDate = null,
  maxDate = null,
  className = ''
}) {
  return (
    <>
      {!clearIcon && (
        <DatePicker
          format="dd-MM-y"
          dayPlaceholder="DD"
          monthPlaceholder="MM"
          yearPlaceholder="YYYY"
          minDate={minDate}
          maxDate={maxDate}
          value={value}
          onChange={onChange}
          onCalendarClose={onBlur}
          className={`w-100 ${className} ${
            errors[name] && touched[name] ? 'error-border' : ''
          }`}
          clearIcon={null}
          calendarIcon={
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="15px"
              viewBox="0 -960 960 960"
              width="15px"
              fill="currentColor"
            >
              <path d="M200-80q-33 0-56.5-23.5T120-160v-560q0-33 23.5-56.5T200-800h40v-80h80v80h320v-80h80v80h40q33 0 56.5 23.5T840-720v560q0 33-23.5 56.5T760-80H200Zm0-80h560v-400H200v400Zm0-480h560v-80H200v80Zm0 0v-80 80Z" />
            </svg>
          }
          disabled={disabled}
          disableCalendar={disabled}
        />
      )}
      {clearIcon && (
        <DatePicker
          format="dd-MM-y"
          dayPlaceholder="DD"
          monthPlaceholder="MM"
          yearPlaceholder="YYYY"
          minDate={minDate}
          maxDate={maxDate}
          value={value}
          onChange={onChange}
          onCalendarClose={onBlur}
          className={`w-100 ${className} ${
            errors[name] && touched[name] ? 'error-border' : ''
          }`}
          clearIcon={value && value !== '' ? <ClearIcon /> : null}
          calendarIcon={
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="15px"
              viewBox="0 -960 960 960"
              width="15px"
              fill="currentColor"
            >
              <path d="M200-80q-33 0-56.5-23.5T120-160v-560q0-33 23.5-56.5T200-800h40v-80h80v80h320v-80h80v80h40q33 0 56.5 23.5T840-720v560q0 33-23.5 56.5T760-80H200Zm0-80h560v-400H200v400Zm0-480h560v-80H200v80Zm0 0v-80 80Z" />
            </svg>
          }
          disabled={disabled}
          disableCalendar={disabled}
        />
      )}
    </>
  )
}

export default InputDatePicker
